import { useState } from 'react'
import { useAuth } from '../../contexts/AuthContext'
import { Search, Menu, Bell } from 'lucide-react'
import { useNotificationRefresh } from '../../contexts/NotificationContext'
import { useLocation, useNavigate } from 'react-router-dom'
import Avatar from '../ui/Avatar'

export default function MobileHeader({ onMenuToggle, onSearchChange }) {
  const { user } = useAuth()
  const { contadorNoLeidas } = useNotificationRefresh()
  const navigate = useNavigate()
  const location = useLocation()
  const [searchQuery, setSearchQuery] = useState('')
  const pathname = location.pathname
  const isHome = pathname === '/'
  const isMascotasList = pathname === '/mascotas'
  const isMascotaEdit = /^\/mascotas\/[^/]+\/edit$/.test(pathname)

  // En mobile el menú inferior suele ser suficiente; evitamos el burger en pantallas donde ya
  // tenemos navegación primaria visible.
  const showBurger = !isHome && !isMascotasList && !isMascotaEdit

  const handleSearchChange = (e) => {
    const value = e.target.value
    setSearchQuery(value)
    if (onSearchChange) {
      onSearchChange(value)
    }
    if (window.mobileSearchHandler) {
      window.mobileSearchHandler(value)
    }
  }

  return (
    <header className={`sticky top-0 z-30 ${isHome ? 'bg-white' : 'px-4 pt-4'}`}>
      <div className={isHome ? 'px-4 pt-2 pb-2' : 'bg-white/95 border border-pastel-pink rounded-[24px] px-3 py-3 shadow-soft backdrop-blur-sm'}>
        <div className="flex items-center gap-2">
          {showBurger && (
            <button
              onClick={() => onMenuToggle && onMenuToggle()}
              className="h-10 w-10 flex items-center justify-center rounded-full bg-mobile-surface text-mobile-muted md:hidden"
              aria-label="Abrir menú"
              type="button"
            >
              <Menu className="w-5 h-5" />
            </button>
          )}

          <div className="relative flex-1">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
            <input
              type="text"
              placeholder="Buscar mascotas, citas…"
              value={searchQuery}
              onChange={handleSearchChange}
              className="w-full pl-9 pr-3 py-2 rounded-full border border-transparent bg-mobile-surface text-mobile-ink text-sm focus:outline-none focus:ring-2 focus:ring-mobile-brand/30"
            />
          </div>

          <button
            onClick={() => navigate('/notificaciones')}
            className="relative h-10 w-10 flex items-center justify-center rounded-full text-mobile-muted"
            aria-label="Notificaciones"
            type="button"
          >
            <Bell className="w-5 h-5" />
            {contadorNoLeidas > 0 && (
              <span className="absolute top-0.5 right-0.5 min-w-[16px] h-[16px] px-1 rounded-full bg-mobile-danger text-white text-[9px] font-bold flex items-center justify-center">
                {contadorNoLeidas > 9 ? '9+' : contadorNoLeidas}
              </span>
            )}
          </button>

          <button
            onClick={() => navigate('/perfil')}
            className="h-9 w-9 rounded-full border-2 border-white shadow-sm overflow-hidden bg-gradient-to-br from-[#c9956c] to-[#e8b89a] flex items-center justify-center"
            type="button"
          >
            <Avatar user={user} size="sm" showStatus={false} />
          </button>
        </div>
      </div>
    </header>
  )
}
